export const BASE_URL = process.env.REACT_APP_BASE_URL;
console.log("BASE_URL", BASE_URL);
